const single_sign_on = {
    forbidden_domains: 'لا يُسمح بنطاقات البريد الإلكتروني العامة.',
    duplicated_domains: 'هناك نطاقات مكررة.',
    invalid_domain_format: 'تنسيق النطاق غير صالح.',
    duplicate_connector_name: 'اسم الموصل مكرر. يرجى اختيار اسم مختلف.',
};
export default Object.freeze(single_sign_on);
